import MainComponent from "components/Main";

export default class EmployeePortfolio extends MainComponent {

    render() {

        const { address } = this.props;

        return (
            <div className="flex col">
                {
                    address.trim().split(' ').map((line, index) => {

                        return (<a
                            className="link"
                            href={line}
                            key={index}
                            target="_blank"
                            rel="noreferrer">
                            {line}
                        </a>);

                    })
                }
            </div>
        );
    }

}
